import { useContext } from 'react';
import { LoginDialogContext } from '~/signalsAndContext/LoginContext';

export default function Awards2024LoginPrompt() {
  const { setShowLoginDialogState } = useContext(LoginDialogContext);
  const signUp = () => setShowLoginDialogState(true);
  return (
    <div className='awards-login-prompt'>
      <span className='txt'>You have not signed in.</span>
      <button className='btn' type='button' onClick={signUp}>Sign In</button>
    </div>
  );
}
